import focus from './focus';
import scroll from './scroll';
import scrollHash from './scroll-hash';
import anchorTabs from './anchor-tabs';

export default {
    'focus': focus,
    'scroll': scroll,
    'scroll-hash': scrollHash,
    'anchor-tabs': anchorTabs,
}
